import "./Footer.css"

const Footer = () => {
    return <div className="footer">Counter Footer</div>
}


export default Footer